import { ComponentProps } from 'react'
import { styled } from 'stitches.config'

type PillOwnProps = ComponentProps<typeof Pill>
export type PillProps = PillOwnProps & {}

export const Pill = styled('div', {
  height: '$4',
  borderRadius: '$3',
  px: '$1',
  fontSize: '$caption',
  lineHeight: '$caption',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'uppercase',

  backgroundColor: 'rgba($$variantColor, 0.15)',
  color: 'rgba($$variantColor, 1)',
  fontWeight: 'bold',

  variants: {
    variant: {
      success: {
        $$variantColor: '$colors$tag-green',
      },
      warning: {
        $$variantColor: '$colors$tag-orange',
      },
      danger: {
        $$variantColor: '$colors$tag-red',
      },
      info: {
        $$variantColor: '$colors$tag-blue',
      },
      productType: {
        backgroundColor: '$primary-700',
        color: '$accent-white',
      },
      unavailable: {
        backgroundColor: '$colors$accent-gray',
        color: '$colors$accent-black',
      },
    },
    mobileOnly: {
      true: {
        display: 'none',
        '@bpInt': {
          display: 'flex',
        },
      },
    },
    desktopOnly: {
      true: {
        display: 'none',
        '@bp1_1': {
          display: 'flex',
        },
      },
    },
  },

  defaultVariants: {
    variant: 'success',
  },
})

Pill.displayName = 'Pill'
